export const getCurrentYear = () => {
  return new Date().toLocaleDateString('ru-RU', { year: 'numeric' })
}
